/* eslint-disable */
<template>
	<section class="full-height">
		<div class="smaller-heading">Zimmer auswählen</div>
		<div class="text">Sie können zwischen einem Zimmer mit Einzelbett oder Doppelbett wählen.
			<p>Alle Zimmer sind mit TV und einem kleinen Bad ausgestattet.</p>
			<p>Toiletten sind im Erdgeschoss</p>
		</div>
		<div class="select-buttons">
			<button class="button" v-on:click="toDateSelect(0)">Einzelzimmer</button>
			<button class="button" v-on:click="toDateSelect(1)">Doppelzimmer</button>
		</div>
	</section>
</template>
<script>
import axios from 'axios'

export default {
	name: 'RoomSelect',

	components: {},

	data () {
		return {
			companies: []
		}
	},

	created () {
		this.fetchData()
	},

	// watch: {
	//   $route: "fetchData"
	// },

	methods: {
		toDateSelect (roomType) {
			this.$router.push({ name: 'dateSelect' })

			this.$store.commit(
				'setRoomType',
				this.$store.state.roomSettings[roomType]
			)
		},
		fetchData () {
			axios
				.get(process.env.API_URL + '/roomSettings')
				.then(resp => {
					// get a better object back for correct city name
					this.$store.commit('setRoomSettings', resp.data)
				})
				.catch(err => {
					console.log(err)
				})
		}
	}
}
</script>
<style scoped>
.smaller-heading {
	font-size: 5em;
	font-weight: 900;
	text-align: center;
	margin-top: 3em;
}
.text {
	font-size: 1.5em;
	text-align: center;
	margin: 2em;
}
.select-buttons {
	margin-top: 3em;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/RoomSelect.vue